import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { useActions } from 'hooks/useActions';
import * as actions from './actions';
import {
  OuterContainer,
  ContainerHeading,
  EmailTabContainer,
  EmailTab,
  EmailContainer,
  SubjectInput,
  SubjectLabel,
} from './styles';
import { Button } from '../../components';
import QuillEditor from 'components/QuillEditor/quillEditorEmail';

export default React.memo(() => {
  const {
    settings: { emails },
    isEmailUpdated,
  } = useSelector((state) => state.settings);

  const { updateEmail, resetUpdatedIds } = useActions(actions);

  const [emailsList, setEmailsList] = useState(emails);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (isEmailUpdated) {
      toast.success('Email updated successfully');
      resetUpdatedIds();
    }
  }, [isEmailUpdated]);

  const getEmailTopicNames = (topic) => {
    if (topic === 'applied') return 'Candidate Applied';
    if (topic === 'rejected') return 'Candidate Rejected';
    if (topic === 'ticket') return 'Take Test';
    if (topic === 'invite') return 'Invite Reviewer';
    if (topic === 'testReminder') return 'Test Reminder';
    if (topic === 'CVReminder') return 'CV Reminder';
  };

  const renderTabs = () =>
    emailsList &&
    emailsList.map((email, index) => (
      <EmailTab active={activeIndex === index} onClick={() => setActiveIndex(index)} key={email._id}>
        {getEmailTopicNames(email.topic)}
      </EmailTab>
    ));

  const updateChanges = (field, value, source, delta) => {
    let isPlaceholder = false;
    if (delta?.ops) {
      for (const d of delta.ops) {
        if (d.insert) {
          if (d.insert.charAt(0) === '[' && d.insert.charAt(d.insert.length - 1) === ']') isPlaceholder = true;
        }
      }
    }
    // isPlaceholder check is because on adding placeholder source is api
    // Added condition because on tab change values are not updating properly
    if ((field === 'enHtml' || field === 'svHtml') && source !== 'user' && !isPlaceholder) return;
    let emailsListCopy = JSON.parse(JSON.stringify(emailsList));
    emailsListCopy[activeIndex][field] = value;
    setEmailsList(emailsListCopy);
  };

  return (
    <OuterContainer>
      <ContainerHeading>Email Template</ContainerHeading>
      <EmailTabContainer grids={emails.length}>{renderTabs()}</EmailTabContainer>
      <EmailTabContainer grids={2} gridGap="35">
        <EmailContainer>
          <SubjectLabel>English Subject</SubjectLabel>
          <SubjectInput
            value={emailsList[activeIndex].enSubject}
            onChange={(e) => updateChanges('enSubject', e.target.value)}
          ></SubjectInput>
          <QuillEditor
            id="enHtml"
            placeholder="Email template"
            className="quill-email"
            height="250px"
            value={emailsList[activeIndex].enHtml}
            onChange={(updatedValue, delta, source) => updateChanges('enHtml', updatedValue, source, delta)}
            addPlaceholder
          />
        </EmailContainer>
        <EmailContainer>
          <SubjectLabel>Swedish Subject</SubjectLabel>
          <SubjectInput
            value={emailsList[activeIndex].svSubject}
            onChange={(e) => updateChanges('svSubject', e.target.value)}
          ></SubjectInput>
          <QuillEditor
            id="svHtml"
            placeholder="Email template"
            className="quill-email"
            height="250px"
            value={emailsList[activeIndex].svHtml}
            addPlaceholder={true}
            onChange={(updatedValue, delta, source) => updateChanges('svHtml', updatedValue, source, delta)}
          />
        </EmailContainer>
      </EmailTabContainer>
      <Button
        small
        primaryBlue
        primaryGreenBorder
        removeMargin
        margin="15px 0 0 0px"
        onClick={() => updateEmail(emailsList)}
      >
        Save
      </Button>
    </OuterContainer>
  );
});
